import { render } from "./Dashboard.vue?vue&type=template&id=a8a673a6&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=a8a673a6&lang=scss&scoped=true"
import "./Dashboard.vue?vue&type=style&index=1&id=a8a673a6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8a673a6"]])

export default __exports__